import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  DateRangePicker,
  Button,
  Select,
  Table,
  TableWithHeader,
  LoadingComponent,
  Modal,
  NoDataFoundTemplate,
} from "../../../components/core";
import sampleData from "../../../features/locker-rental-report/sample-response.json";
import { useQuery } from "@apollo/client";
import {
  QUERY_COMPANY_BRANCHES,
  QUERY_COMPANY_NKCNAME,
  QUERY_LOCKER_NAME,
  QUERY_LOCKER_TYPE,
} from "../../../features/locker-rental-report/locker-rental-graphql";
import TableWithHeader2 from "../../../components/core/table-with-header/index2";

const LockerRentalReport = () => {
  //variables
  const [noResultSearch, setNoResultSearch] = useState(true);
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [partnerName, setPartnerName] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [newNoData, setnewNoData] = useState(false);
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  const serviceType = [
    { value: "1", name: "Dropoff" },
    { value: "2", name: "Shipout" },
  ];

  const doorSizeOptions = [
    { value: "1", name: "Small" },
    { value: "2", name: "Medium" },
    { value: "3", name: "Large" },
  ];

  //setter variables
  const [lockerType, setLockerType] = useState([]);
  const [selectedLockerType, setSelectedLockerType] = useState("-1");
  const [lockerName, setLockerName] = useState([]);
  const [selectedLockerName, setSelectedLockerName] = useState("-1");
  const [partnerCompany, setPartnerCompany] = useState([]);
  const [selectedPartnerCompany, setSelectedPartnerCompany] = useState("-1");
  const [partnerBranches, setPartnerBranch] = useState([]);
  const [selectedPartnerBranch, setSelectedPartnerBranch] = useState("-1");
  const [selectedServiceType, setSelectedServiceType] = useState("0");
  const [searchResultHeader, setSearchResultHeader] = useState("");
  const [isTableEmpty, setIsTableEmpty] = useState(true);
  const [filteredTableData, setFilteredTableData] = useState([]);

  const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);
  const fetchLockerName = useQuery(QUERY_LOCKER_NAME, {
    variables: {
      operatorId: operatorId,
      selectedLockerType: selectedLockerType,
    },
  });
  const fetchCompanyName = useQuery(QUERY_COMPANY_NKCNAME, {
    variables: {
      operatorId: operatorId,
    },
  });
  const fetchCompanyBranch = useQuery(QUERY_COMPANY_BRANCHES, {
    variables: {
      operatorId: operatorId,
      selectedPartnerCompany: selectedPartnerCompany,
    },
  });
  //To display search result in header
  function handleSearchResultHeader() {
    const lockerTypeName =
      selectedLockerType === "-1"
        ? "ALL Locker types"
        : selectedLockerType === "1"
        ? "Parcel Locker"
        : "Fridge Locker";

    let partnerCompanyName = "ALL Partners";
    if (selectedPartnerCompany !== "-1" && selectedPartnerCompany !== "") {
      const foundPartnerCompany = partnerCompany.find(
        (item) => item.value.toString() === selectedPartnerCompany
      );
      partnerCompanyName = foundPartnerCompany
        ? foundPartnerCompany.name
        : "ALL Partners";
    }
    const partnerBranchValue =
      selectedPartnerBranch === "-1" || selectedPartnerBranch === ""
        ? "ALL Branches"
        : partnerBranches.find(
            (item) => item.value.toString() === selectedPartnerBranch
          );

    const partnerBranchText =
      partnerBranchValue && typeof partnerBranchValue === "object"
        ? partnerBranchValue.name
        : partnerBranchValue || "ALL Branches";

    const lockerNameValue =
      selectedLockerName != "200"
        ? lockerName.find(
            (item) => item.value.toString() === selectedLockerName
          )
        : "ALL Lockers";

    const lockerNameText = lockerNameValue
      ? `${
          selectedLockerName === "200" ? lockerNameValue : lockerNameValue.name
        }`
      : "ALL Lockers";

    const serviceTypeValue =
      selectedServiceType === "0"
        ? { name: "ALL Service Types" }
        : serviceType.find((item) => item.value === selectedServiceType);
    const serviceTypeText = serviceTypeValue
      ? `${serviceTypeValue.name}`
      : "ALL Service Types";
    setSearchResultHeader(
      `for ${lockerTypeName}, ${lockerNameText}, ${partnerCompanyName}, ${partnerBranchText}, ${serviceTypeText}, from ${formatDate(
        startDate
      )} to ${formatDate(endDate)}`
    );
  }

  //date formatter
  function formatDate(inputDate) {
    if (inputDate == null) {
      return "";
    }
    const date = new Date(inputDate);
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour12: false,
    };
    return date.toLocaleDateString(undefined, options);
  }

  //To Fetch Company Branches
  useEffect(() => {
    if (fetchCompanyBranch.data) {
      let tempData = [];
      fetchCompanyBranch.data.searchBranches.forEach((element, index) => {
        tempData.push({
          value: element.partnerBranchId,
          name: element.partnerBranch,
        });
      });
      setPartnerBranch(tempData);
    }
  }, [fetchCompanyBranch.data]);

  //To Fetch Company Name
  useEffect(() => {
    if (fetchCompanyName.data) {
      let tempData = [];
      fetchCompanyName.data.partners.forEach((element, index) => {
        tempData.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      setPartnerCompany(tempData);
    }
  }, [fetchCompanyName.data]);

  //to fetch lockerType
  useEffect(() => {
    if (fetchLockerType.data) {
      let tempData = [];
      fetchLockerType.data.lockerTypes.forEach((element, index) => {
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });
      setLockerType(tempData);
    }
  }, [fetchLockerType.data]);

  //To Fetch Locker Name

  useEffect(() => {
    if (fetchLockerName.data) {
      let tempData = [
        {
          value: "200",
          name: "-- All --",
        },
      ];
      fetchLockerName.data.lockers.forEach((element, index) => {
        tempData.push({
          value: element.lockerId,
          name: element.lockerName,
        });
      });
      setLockerName(tempData);
    }
  }, [fetchLockerName.data]);

  //To fetch table data
  useEffect(() => {
    if (sampleData.data) {
      let tempData = [];
      let tempName = [];
      let tempLocker = [];
      let tempBranch = [];
      sampleData.data.lockerRentalsReport.partners.forEach((e, i) => {
        let obj = { ...e };
        let tempArr = [];
        tempName.push({
          value: obj.partnerId,
          name: obj.partnerName,
        });
        e.transactions.forEach((e1, i1) => {
          let obj1 = { ...e1 };

          obj1.serviceTypeId = serviceType.find(
            (x) => x.value === e1.serviceTypeId.toString()
          ).name;

          obj1.doorSize = doorSizeOptions.find(
            (x) => x.value === obj1.doorSize.toString()
          ).name;

          obj1.excessFee =
            obj1.lengthOfStay < obj1.initialFreeHrs ? 0 : obj1.excessFee;

          //
          obj1.total =
            parseFloat(obj1.initialFee, 2) + parseFloat(obj1.excessFee, 2);

          obj1.total = `₱${obj1.total}`;

          obj1.initialFee = `₱${obj1.initialFee}`;
          obj1.excessFee = `₱${obj1.excessFee}`;

          obj1.transactionFee = `₱${obj1.transactionFee}`;

          obj1.initialFreeHrs = `${obj1.initialFreeHrs} hrs`;
          obj1.lengthOfStay = `${obj1.lengthOfStay} hrs`;
          obj1.date = formatDate(obj1.date);
          tempArr.push(obj1);
        });

        obj.transactions = tempArr;
        obj.header = searchResultHeader;
        tempData.push(obj);
      });
      setTableData(tempData);
      setPartnerName(tempName);
      setPartnerCompany(tempName);
    }
  }, [sampleData.data]);

  console.log({ tableData });

  //To fetch locker Type
  useEffect(() => {
    if (fetchLockerType.data) {
      let tempData = [];
      fetchLockerType.data.lockerTypes.forEach((element, index) =>
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        })
      );
      setLockerType(tempData);
    }
  }, [fetchLockerType.data]);

  const [lockerTotal, setLockerTotal] = useState();
  const [partnerTOtal, setPartnerTotal] = useState();

  function FilterDataTable() {
    const startDateObject = startDate ? new Date(startDate) : null;
    if (startDateObject) {
      startDateObject.setDate(startDateObject.getDate() - 1);
    }
    // const startDateObject = startDate ? new Date(startDate).setDate(new Date(startDate) - 1) : null;
    const endDateObject = endDate ? new Date(endDate) : null;
    if (endDateObject) {
      endDateObject.setDate(endDateObject.getDate() + 1);
    }
    // const endDateObject = endDate ? new Date(endDate).setDate(new Date(endDate) + 1) : null;

    let totalPartners = 0;
    let totalLockers = 0;

    // Function to get service type name based on ID
    const getServiceTypeName = (serviceTypeId) => {
      const serviceTypeObject = serviceType.find(
        (item) => item.value === serviceTypeId
      );
      return serviceTypeObject ? serviceTypeObject.name : "";
    };

    // Apply filters to the data
    const filteredData = tableData.map((partner) => {
      const filteredTransactions = partner.transactions.filter(
        (transaction) => {
          console.log({ transaction });
          // Apply filters based on selected options
          // const isLockerTypeMatch =
          // 	selectedLockerType === "-1" ||
          // 	transaction.lockerTypeId === selectedLockerType;
          const isLockerNameMatch =
            (selectedLockerName === "200" && selectedLockerType == "1") ||
            selectedLockerType == "-1"
              ? true
              : transaction.lockerId.toString() === selectedLockerName;
          const isPartnerCompanyMatch =
            selectedPartnerCompany === "-1" ||
            partner.partnerId.toString() === selectedPartnerCompany;
          const isPartnerBranchMatch =
            selectedPartnerBranch === "-1" ||
            transaction.partnerBranchId.toString() === selectedPartnerBranch;
          const isServiceTypeMatch =
            selectedServiceType === "0" ||
            transaction.serviceTypeId ===
              getServiceTypeName(selectedServiceType);
          const isDateRangeMatch =
            startDateObject && endDateObject
              ? new Date(transaction.date) >= startDateObject &&
                new Date(transaction.date) <= endDateObject
              : true;

          return (
            // isLockerTypeMatch &&
            isLockerNameMatch &&
            isPartnerCompanyMatch &&
            isPartnerBranchMatch &&
            isServiceTypeMatch &&
            isDateRangeMatch
          );
        }
      );

      if (filteredTransactions.length > 0) {
        totalLockers += filteredTransactions.length;
        totalPartners++;
      }

      const transactionsWithServiceTypeNames = filteredTransactions.map(
        (transaction) => ({
          ...transaction,
          serviceTypeName: getServiceTypeName(transaction.serviceTypeId),
        })
      );

      console.log({ transactionsWithServiceTypeNames });

      return {
        ...partner,
        transactions: filteredTransactions,
        // transactions: transactionsWithServiceTypeNames, // Update here to use transactionsWithServiceTypeNames
      };
    });

    setFilteredTableData(filteredData);

    // setPartnerName(totalPartners);
    setLockerTotal(totalLockers);

    const isEmptyTransActions = filteredData.every(
      (partner) => partner.transactions.length === 0
    );

    if (isEmptyTransActions) {
      setNoResultSearch(true);
      setIsTableEmpty(true);
      setnewNoData(true);
    } else {
      setNoResultSearch(false);
      setIsTableEmpty(false);
      setnewNoData(false);
    }
  }

  const EmptyCriteriaHandler = () => {
    if (selectedLockerType != "-1" && selectedLockerName === "-1") {
      setNoResultSearch(true);
      setIsTableEmpty(true);
      setnewNoData(false);
      console.log("here" + newNoData);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Locker",
        message: `Please select a locker name.`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return false;
    }
    if (selectedLockerType == "2" && selectedLockerName === "200") {
      console.log("Error: No locker was found");
      setNoResultSearch(true);
      setIsTableEmpty(true);
      setFilteredTableData([]);
      setnewNoData(true);
      return false;
    }
    setNoResultSearch(false);
    setIsTableEmpty(false);
    setnewNoData(false);
    return true;
  };

  const handleSearch = (event, data) => {
    setIsLoading(true);
    handleSearchResultHeader();
    setFilteredTableData([]);
    // setTableData([]);
    if (startDate == "" && endDate == "") {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Date",
        message: `No date range selected.`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      setIsLoading(false);
      return;
    } else if (endDate == "") {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Date",
        message: `No end date was selected.`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      setIsLoading(false);
      return;
    } else if (startDate > endDate) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Date",
        message: `Start date must be before end date.`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      setIsLoading(false);
      return;
    } else if (startDate == "") {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Date",
        message: `No start date was selected.`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      setIsLoading(false);
      return;
    } else {
      var boolOne = EmptyCriteriaHandler();
      if (boolOne) {
        FilterDataTable();
      }
    }
    if (selectedPartnerCompany != "-1") {
      setPartnerTotal(filteredTableData.length - 1);
    } else {
      setPartnerTotal(partnerName.length);
    }
  };

  console.log({ selectedServiceType });
  return (
    <ContentContainer containerTitle={"Locker Rental Fees Report"}>
      <h2 className={"font-bold"}>Locker:</h2>
      <div className={"grid grid-cols-2 w-1/2 gap-y-2"}>
        <p>Locker Type:</p>
        <Select
          items={lockerType}
          value={selectedLockerType}
          defaultOption={{ value: "-1", name: "-- ALL--" }}
          onChange={(event) => {
            setSelectedLockerType(event.target.value);
            setSelectedLockerName("-1");
          }}
        />
        <p>Locker Name:</p>
        <Select
          items={lockerName}
          value={selectedLockerName}
          defaultOption={{ value: "-1", name: "-- Select Locker Name --" }}
          onChange={(event) => {
            setSelectedLockerName(event.target.value);
          }}
        />
      </div>

      <h2 className={"font-bold"}>Partner:</h2>
      <div className={"grid grid-cols-2 w-1/2 gap-y-2"}>
        <p>Partner Company:</p>
        <Select
          items={partnerCompany}
          value={selectedPartnerCompany}
          defaultOption={{ value: "-1", name: "-- ALL --" }}
          onChange={(event) => {
            setSelectedPartnerBranch("-1");
            setSelectedPartnerCompany(event.target.value);
          }}
        />
        <p>Partner Branch:</p>
        <Select
          items={partnerBranches}
          value={selectedPartnerBranch}
          defaultOption={{ value: "-1", name: "-- Select Partner Branch --" }}
          onChange={(event) => {
            setSelectedPartnerBranch(event.target.value);
          }}
        />
      </div>
      <div className={"grid grid-cols-2 w-1/2 gap-y-2 mt-5"}>
        <h2 className={"font-bold"}>Service type:</h2>
        <Select
          items={serviceType}
          value={selectedServiceType}
          defaultOption={{ value: "0", name: "-- ALL --" }}
          onChange={(event) => {
            setSelectedServiceType(event.target.value);
          }}
        />
      </div>
      <h2 className={"font-bold"}>Date range:</h2>
      <DateRangePicker
        className={"w-1/2"}
        startDate={startDate}
        endDate={endDate}
        onChange={(event) => {
          if (event.target.name === "signupDateFrom") {
            setStartDate(event.target.value);
          } else {
            setEndDate(event.target.value);
          }
        }}
      />

      <div className="grid grid-cols-2 w-1/2 gap-y-2">
        <div></div>
        <u
          className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
          onClick={() => {
            setSelectedLockerType("-1");
            setSelectedLockerName("-1");
            setSelectedPartnerCompany("-1");
            setSelectedPartnerBranch("-1");
            setSelectedServiceType("0");
            setStartDate(new Date().toISOString().split("T")[0]);
            setEndDate(new Date().toISOString().split("T")[0]);
          }}
        >
          <i className="fas fa-undo my-auto"></i>
          <p className="ml-1">Reset</p>
        </u>
      </div>

      <Button
        value={"Search"}
        onClick={handleSearch}
        className={"w-40 h-8 m-5"}
      />
      {!isTableEmpty && (
        <div className="Table handler">
          <div className={"bg-yellow-400 p-2 border border-black "}>
            <span className="text-center">
              <h1 className={"font-bold"}>LOCKER RENTAL FEES</h1>
              <p className={"font-bold"}>{searchResultHeader}</p>
            </span>
          </div>

          <div className="pt-5">
            <div className="border border-black h-20 text-center w-1/4 m-auto">
              <div className="flex flex-col justify-center pt-3">
                <div>Total Partners: {partnerTOtal}</div>
                <div>Total Lockers: {lockerTotal}</div>
              </div>
            </div>
          </div>

          {filteredTableData.map((key, index) => (
            <div className="mt-5">
              {key.transactions.length > 0 && (
                <TableWithHeader2
                  key={index}
                  title={key.partnerName}
                  withLink={false}
                  linkField={false}
                  header={[
                    { header_name: "Locker Name", key: "lockerName" },
                    { header_name: "Service Type", key: "serviceTypeId" },
                    { header_name: "Date", key: "date" },
                    { header_name: "Waybill", key: "waybill" },
                    { header_name: "Door Size", key: "doorSize" },
                    {
                      header_name: "Initial Free Hours",
                      key: "initialFreeHrs",
                    },
                    { header_name: "Initial Fee", key: "initialFee" },

                    {
                      header_name: "Total Length of Stay",
                      key: "lengthOfStay",
                    },
                    { header_name: "Excess Fee", key: "excessFee" },
                    { header_name: "Total", key: "total" },
                    {
                      header_name: `${searchResultHeader} - ${key.partnerName}`,
                      key: "blank",
                    },
                  ]}
                  item={key.transactions}
                  courierComp={key.partnerName.toString()}
                />
              )}
            </div>
          ))}
        </div>
      )}
      {newNoData && <NoDataFoundTemplate />}

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
};
export default LockerRentalReport;
